<template>
  <svg
    :width="width ? width : height ? height : 18"
    :height="height ? height : width ? width : 21"
    viewBox="0 0 18 21"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M1.722 18.225c0 1.013.821 1.834 1.834 1.834h11.002a1.834 1.834 0 0 0 1.834-1.834V5.39H1.722v12.835zm10.391-9.78a.611.611 0 0 1 1.223 0v8.558a.611.611 0 0 1-1.223 0V8.446zm-3.667 0a.611.611 0 0 1 1.222 0v8.558a.611.611 0 0 1-1.222 0V8.446zm-3.667 0a.611.611 0 0 1 1.222 0v8.558a.611.611 0 0 1-1.222 0V8.446zm12.224-6.723h-4.584l-.36-.714A.917.917 0 0 0 11.24.5H6.871a.906.906 0 0 0-.818.508l-.359.714H1.111a.611.611 0 0 0-.611.612v1.222c0 .338.274.611.611.611h15.892a.611.611 0 0 0 .611-.61V2.333a.611.611 0 0 0-.611-.612z"
      :fill="iconColor"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
export default {
  name: 'trash',
  props: {
    iconColor: {
      type: String,
      default: '#fff',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
